import * as analytics from '../api/analytics';
import * as matchers from './pathMatchers';

export default function trackPageView({ pathname, search }, extra?: any) {
  analytics.trackEvent('page', 'view', 'page', {
    app: matchers.matchInAppQueryParam(search),
    pathname,
    search,
    ...extra,
  });
}

// split out path based trackEvents, so they can be tracked once js is loaded
export function trackPathViews({ pathname }) {
  if (matchers.matchHomeProfileSlug(pathname)) {
    analytics.trackEvent('home-profile', 'view', 'page', {
      slug: matchers.matchHomeProfileSlug(pathname),
    });
  } else if (matchers.matchResaleOfferPortalPageName(pathname)) {
    analytics.trackEvent('resale-offer-portal', 'view', 'page', {
      page: matchers.matchResaleOfferPortalPageName(pathname),
    });
  }
}
